import Router from 'vue-router'

export const baseRouter = [
    {
        path: '/',
        name: '卖方管理员',
        redirect: '/login',
        component: () => import("@/views/layout/index.vue"),
    },
    {
        path: '/login',
        component: () => import("@/views/login/index.vue"),
        name: '登录',
        meta: {
            hidden: false,
        },
    },
    {
        path: '/logon',
        component: () => import("@/views/logon/index.vue"),
        name: '注册',
        meta: {
            hidden: false,
        },
    },
    {
        path: '/partner/:type/:id?',
        component: () => import("@/views/sellerAdmin/partner/index.vue"),
        name: 'KA入驻',
        meta: {
            hidden: true,
        },
    },
    {
        path: '/supplier/:type/:id?',
        component: () => import("@/views/sellerAdmin/supplier/index.vue"),
        name: '供应商入驻',
        meta: {
            hidden: true,
        },
    },
    {
        path: '/logistics/:type/:id?',
        component: () => import("@/views/sellerAdmin/logistics/index.vue"),
        name: '物流入驻',
        meta: {
          hidden: false,
        },
    },
    {
      path: '/test',
        component: () => import("@/test/index.vue"),
        name: '轨迹图',
        meta: {
          hidden: false,
        },
    }
    // type 1管理端 2商家端

]

export const resetRouter =  (router) => {
    const createRouter = () =>
      new Router({
        base: '/',
        mode: 'history',
        routes:baseRouter,
        scrollBehavior: () => ({ x: 0, y: 0 }),
      })
    // 用初始化的matcher替换当前router的matcher
    router.matcher = createRouter.matcher
}
